import { render, staticRenderFns } from "./Asset-Type-Icon.vue?vue&type=template&id=0a74999e&scoped=true&lang=pug"
import script from "./Asset-Type-Icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./Asset-Type-Icon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Asset-Type-Icon.vue?vue&type=style&index=0&id=0a74999e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a74999e",
  null
  
)

export default component.exports